<template>
    <div class="row align-items-center justify-content-center" style="min-height: 100vh">
        <div class="col-12 col-md-8 col-xl-6">
            <div class="row">
                <h5 class="col-6 text-bold">{{ __('Change password') }}</h5>

                <div class="col-6 d-flex justify-content-end">
                    <LocaleSelect></LocaleSelect>
                </div>
            </div>

            <Card>
                <div class="row">
                    <div class="col-xl-12 col-12">
                        <template>
                            <form @submit.prevent="submit" class="mt-3">
                                <FormInput
                                    :class="{'is-danger': errors.has('password')}"
                                    :label="__('New password')"
                                    name="password"
                                    ref="password"
                                    type="password"
                                    v-model="user.password"
                                    v-validate="'required|min:6'"
                                />

                                <FormInput
                                    :class="{'is-danger': errors.has('password_confirmation')}"
                                    :label="__('Confirm new password')"
                                    data-vv-as="password"
                                    name="password_confirmation"
                                    type="password"
                                    v-model="user.password2"
                                    v-validate="'required|confirmed:password'"
                                />

                                <RequestButton
                                    :on-click="submit"
                                    class="btn btn-block btn-sm btn-primary my-3"
                                >
                                    {{ __('Change password') }}
                                </RequestButton>

                                <div class="text-center">
                                    <span class="text-black-sm">
                                        {{ __('Don\'t have an account?') }}
                                        <router-link to="/register">
                                            {{ __('Register') }}
                                        </router-link>
                                    </span>
                                </div>

                                <div class="text-center mt-2">
                                    <span class="text-black-sm">
                                        {{ __('Already have an account?')}}
                                        <router-link to="/login">{{ __('Login') }}</router-link>
                                    </span>
                                </div>
                            </form>
                        </template>
                    </div>
                </div>
            </Card>
        </div>
    </div>
</template>

<script>
import LocaleSelect from '../../plugins/LocaleSelect'
import { __ } from '../../translations/localization'

export default {
  name: 'PasswordChange',

  components: { LocaleSelect },

  data () {
    return {
      user: {
        token: this.$route.query.token,
        password: null,
        password2: null
      }
    }
  },

  methods: {
    submit () {
      return this.$validator.validate().then((valid) => {
        if (valid) {
          return this.$api.auth.changePassword(this.user)
            .then(() => {
              this.$toaster.success(__('Password successfully changed!'))
              this.$router.push('/login')
            })
            .catch((response) => {
              this.setErrorsFromResponse(response)
            })
        }
      })
    }
  }
}
</script>

